import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = { class: "right-container" }
const _hoisted_4 = { class: "export-modal-header" }
const _hoisted_5 = { class: "export-modal-content" }
const _hoisted_6 = { class: "export-option" }
const _hoisted_7 = { class: "checkbox-label" }
const _hoisted_8 = { class: "export-option" }
const _hoisted_9 = { class: "checkbox-label" }
const _hoisted_10 = { class: "export-modal-footer" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartView = _resolveComponent("ChartView")!
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_CardPanel = _resolveComponent("CardPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ChartView, {
        ref: "chartView",
        selectedColumns: _ctx.selectedColumns,
        csvData: _ctx.csvData,
        columnTypes: _ctx.cardColumnTypes,
        columnNames: _ctx.cardcolumnNames,
        relationType: _ctx.cardrelationType,
        invalidIndices: _ctx.invalidIndices,
        invalid_range: _ctx.cardinvalid_range,
        invalid_pairs: _ctx.cardinvalid_pairs,
        threeColumnRules: _ctx.cardThreeColumnRules,
        onDatasetChanged: _ctx.handleDatasetChanged,
        onWorkflowModeChanged: _ctx.handleWorkflowModeChanged,
        onShowExportDialog: _ctx.handleShowExportDialog
      }, null, 8, ["selectedColumns", "csvData", "columnTypes", "columnNames", "relationType", "invalidIndices", "invalid_range", "invalid_pairs", "threeColumnRules", "onDatasetChanged", "onWorkflowModeChanged", "onShowExportDialog"]),
      _createVNode(_component_TableComponent, {
        ref: "tableComponent",
        onColumnsChanged: _ctx.handleSelectedColumnsUpdate,
        onCsvDataChanged: _ctx.handleCsvDataUpdate,
        onRulesUpdate: _ctx.handleRulesRefined,
        highlightedIndices: _ctx.invalidIndices,
        activeHighlightColumns: _ctx.cardcolumnNames,
        sort_conditions: _ctx.cardsort_conditions,
        sortedIndices: _ctx.cardsortedIndices,
        currentCardType: _ctx.currentCardType,
        validationCards: _ctx.validationCards
      }, null, 8, ["onColumnsChanged", "onCsvDataChanged", "onRulesUpdate", "highlightedIndices", "activeHighlightColumns", "sort_conditions", "sortedIndices", "currentCardType", "validationCards"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CardPanel, {
        selectedColumns: _ctx.selectedColumns,
        csvData: _ctx.csvData,
        rulesUpdate: _ctx.refinedRules,
        currentDatasetLoadingId: _ctx.currentDatasetLoadingId,
        onCardClicked: _ctx.handleCardClicked,
        onClearVisualization: _ctx.handleClearVisualization,
        onValidationCardsUpdated: _ctx.handleValidationCardsUpdated,
        onRulesRefreshRequested: _ctx.handleRulesRefresh
      }, null, 8, ["selectedColumns", "csvData", "rulesUpdate", "currentDatasetLoadingId", "onCardClicked", "onClearVisualization", "onValidationCardsUpdated", "onRulesRefreshRequested"])
    ]),
    (_ctx.showExportModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeExportDialog && _ctx.closeExportDialog(...args)))
        }, [
          _createElementVNode("div", {
            class: "export-modal",
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Export Options", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeExportDialog && _ctx.closeExportDialog(...args)))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.exportOptions.validationRules) = $event)),
                    class: "export-checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.exportOptions.validationRules]
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _cache[8] || (_cache[8] = _createTextVNode(" Export Validation Rules (JSON File) "))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exportOptions.detectFunctions) = $event)),
                    class: "export-checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.exportOptions.detectFunctions]
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _cache[10] || (_cache[10] = _createTextVNode(" Export Detect Functions (Python File) "))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "confirm-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmExport && _ctx.confirmExport(...args))),
                disabled: 
              !_ctx.exportOptions.validationRules && !_ctx.exportOptions.detectFunctions
            
              }, " Confirm Export ", 8, _hoisted_11)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}